import { render, staticRenderFns } from "./BudgetTotals.vue?vue&type=template&id=e2d6493c&"
import script from "./BudgetTotals.vue?vue&type=script&lang=js&"
export * from "./BudgetTotals.vue?vue&type=script&lang=js&"
import style0 from "./BudgetTotals.vue?vue&type=style&index=0&id=e2d6493c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports